import { CatHeading } from '@blocks-react/components/Heading';
import { NO_SERVICE_INSIGHTS_IMG } from '../../../common/constants';
import { serviceInsightEmptyStateProps } from '../../types';

export const ServiceInsightEmptyState = ({
  serviceInsightTranslation: { noServiceInsight, noServiceRecommendation }
}: serviceInsightEmptyStateProps) => {
  return (
    <div className="d-flex my-4 flex-column justify-content-center align-items-center cat-u-padding-top-xxl cat-u-padding-bottom-xxl">
      <img
        alt={noServiceInsight}
        src={NO_SERVICE_INSIGHTS_IMG}
        loading="lazy"
      />
      <CatHeading variant="label-lg" className="my-3">
        {noServiceInsight}
      </CatHeading>
      <CatHeading variant="body-sm" className="w-25 text-center">
        {noServiceRecommendation}
      </CatHeading>
    </div>
  );
};
